import { useParams } from 'react-router-dom';

const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const SESSION_ID_REGEX = /^SESSION~[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const isGuidValidator = (value: string) => GUID_REGEX.test(value);

export type Param = 'customerId' | 'resultId' | 'sessionId';
type ParamValidator = (value: string) => boolean;

const paramValidators: Record<Param, ParamValidator> = {
  customerId: isGuidValidator,
  resultId: isGuidValidator,
  sessionId: (value: string) => SESSION_ID_REGEX.test(value),
};

export function useValidatedParams<T extends readonly Param[]>(
  ...paramsToValidate: T
):
  | {
      [K in T[number]]: string;
    }
  | undefined {
  const params = useParams();

  const result = {} as {
    [K in T[number]]: string;
  };

  for (const param of paramsToValidate) {
    const value = params[param];
    if (typeof param === 'string' && paramValidators[param](value)) {
      result[param] = value;
    } else {
      return undefined;
    }
  }

  return result;
}
